import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent } from 'core/components';
import { withLocale } from 'core/decorators';
import { BlockTitle, Icon, Link } from 'core/components/Framework7';
import { openLinkInBrowser, versionCodeToVersionNumber } from 'core/module/operations';

import services from 'core/services';
import classes from './styles.module.css';

import sikaLogo from '../../../assets/images/logo-sika.svg';

class Info extends PureComponent {
  constructor(props) {
    super(props)
  }

  get initialValue() {
    const { env } = this.props;

    const deviceInfo = services.storage.get('device_info');
    // console.log('info component, deviceInfo: ', deviceInfo)
    const appVersion = versionCodeToVersionNumber(deviceInfo ? deviceInfo.appVersion : (!this.$device.cordova || process.env.TARGET === "web") ? env.apps.pwa.currentVersion.currentRelease : null)

    return {
      appVersion: appVersion,

      //info
      email: env ? env.info ? env.info.email ? env.info.email : null : null : null,
      phone: env ? env.info ? env.info.phone ? env.info.phone : null : null : null,
      aboutUs: env ? env.info ? env.info.aboutUs ? env.info.aboutUs : null : null : null,
      privacyPolicy: env ? env.info ? env.info.privacyPolicy ? env.info.privacyPolicy : null : null : null,
      customerClubUrl: env ? env.info ? env.info.customerClubUrl ? env.info.customerClubUrl : null : null : null,

      //socialNetworks
      instagramActive: env ? env.socialNetworks ? env.socialNetworks.instagram ? env.socialNetworks.instagram.active ? env.socialNetworks.instagram.active : null : null : null : null,
      instagramUrl: env ? env.socialNetworks ? env.socialNetworks.instagram ? env.socialNetworks.instagram.url ? env.socialNetworks.instagram.url : null : null : null : null,
      telegramActive: env ? env.socialNetworks ? env.socialNetworks.telegram ? env.socialNetworks.telegram.active ? env.socialNetworks.telegram.active : null : null : null : null,
      telegramUrl: env ? env.socialNetworks ? env.socialNetworks.telegram ? env.socialNetworks.telegram.url ? env.socialNetworks.telegram.url : null : null : null : null,
    }
  }

  renderDetail(icon, detail) {
    return (
      <div>
        <Icon icon={`mdi-${icon}`} style={{ color: "#E73535" }} />
        <div style={{ display: "inline", padding: "0 10px", margin: "0 10px", borderRight: "1px solid gray" }}>{detail}</div>
      </div>
    )
  }

  render() {
    const env = this.initialValue;

    return (
      <div className={classes.container}>
        <BlockTitle className={classes.title}>
          {'اپلیکیشن خرید آنلاین فروشگاه اینترنتی'}
        </BlockTitle>

        <div className={`${classes.logo} logo-color`} />

        <div className={classes.websiteLinks}>
          <div>
            <Link external
              target="_top"
              href={`mailto:${env.email}`}
              text={env.email}
              icon={'mdi-email'}
              className={classes.icon}
            />
          </div>
          <div>
            <Link external
              target="_top"
              href={`tel:${env.phone}`}
              text={env.phone}
              icon={'mdi-face-agent'}
              className={classes.icon}
            />
          </div>
        </div>
        <div className={classes.externalLinks}>
          <p>
            <Link external
              target="_blank"
              href={false}
              external
              text={'درباره ما'}
              className={classes.icon}
              onClick={() => { window.open(env.aboutUs, '_system'); return false; }}
            />
          </p>
          <p>
            <Link external
              target="_blank"
              href={false}
              external
              text={'قوانین و مقررات'}
              className={classes.icon}
              onClick={() => { window.open(env.privacyPolicy, '_system'); return false; }}
            />
          </p>
          <p>
            <Link external
              target="_blank"
              href={false}
              external
              text={'باشگاه مشتریان'}
              className={classes.icon}
              onClick={() => { window.open(env.customerClubUrl, '_system'); return false; }}
            />
          </p>
        </div>
        <div className={classes.socialNetworkLinks}>
          <p>
            {'ما را در شبکه‌های اجتماعی دنبال کنید'}
          </p>
          {env.telegramActive === true &&
            <Link
              href={false}
              external
              target="_blank"
              icon={'mdi-telegram'}
              onClick={() => { window.open(env.telegramUrl, '_system'); return false; }}
            />
          }
          {env.instagramActive === true &&
            <Link
              href={false}
              external
              target="_blank"
              icon={'mdi-instagram'}
              onClick={() => { window.open(env.instagramUrl, '_system'); return false; }}
            />
          }
        </div>

        {/* TODO add image to this */}
        <div className={classes.developerTeam}>
          <Link external
            target="_blank"
            href={false}
            external
            text={'طراحی و توسعه توسط شرکت سیکا'}
            className={classes.contactUs}
            onClick={() => { window.open("https://sikabiz.com", '_system'); return false; }}
          />

          <img src={ sikaLogo} className={classes.sikaLogo } />
        </div>

        <p className={classes.versionBox}>
          {env.appVersion ? `نسخه ${env.appVersion}` : 'آخرین نسخه'}
        </p>
      </div>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {
    openLinkInBrowser,
  }
)(withLocale('address_form')(autobind(Info)))
